import React from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

const RefundPolicy = () => {
  return (
    <div className="w-full min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow flex-col flex items-center justify-center">
        <div className="w-[70%] mx-auto p-6 bg-white my-24">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Refund Policy
          </h1>
          <p className="text-sm text-gray-600 italic mb-6">
            Last Updated: February 15, 2025
          </p>

          <p className="text-gray-700 mb-6">
            This Refund Policy (“Policy”) applies to all payments made by
            clients (“Client” or “you”) to Globelink Techservices (OPC) Private
            Limited (“Globelink,” “we,” or “us”) in connection with our training
            and placement facilitation services (the “Services”), as outlined in
            the Agreement for Training and Placement Services (the “Agreement”).
            By purchasing or using our Services, you acknowledge and agree to be
            bound by the terms of this Policy.
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              Overview
            </h2>
            <p className="text-gray-700">
              <span className="font-medium text-[#75000e]">
                Limited Refund Framework.
              </span>{" "}
              In principle, all payments made to Globelink are non-refundable
              unless (a) otherwise required by law, or (b) expressly provided
              for under this Policy.
              <br />
              <span className="font-medium text-[#860F0B]">
                Contractual Reference.
              </span>{" "}
              This Policy is an integral part of the Agreement. Should any
              conflict arise between the Agreement and this Policy, the
              Agreement shall govern, except as specifically stated herein
              regarding refunds.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              Refund Eligibility: 90-Day Placement Outcome
            </h2>
            <p className="text-gray-700">
              <span className="font-medium text-[#75000e]">
                90-Day Placement Commitment.
              </span>{" "}
              Upon execution of the Agreement, Globelink will use reasonable
              efforts to place the Client in employment or contractual
              engagement with one of our partnering companies (the “Placement”)
              within 90 (ninety) days from the Effective Date of the Agreement.
              <br />
              <span className="font-medium text-[#860F0B]">
                Refund Condition.
              </span>{" "}
              If Globelink is unable to secure for the Client any offer of
              employment or contractual engagement within 90 days from the
              Effective Date, the Client may request a refund. This request must
              be in writing and submitted within 10 (ten) days following the
              expiration of the 90-day period.
              <br />
              <span className="font-medium text-[#75000e]">
                Refund Fulfillment.
              </span>{" "}
              Upon timely receipt and verification of eligibility, Globelink
              will process a full refund of the Service Fee previously paid by
              the Client under the Agreement. This refund shall be the sole and
              exclusive remedy for the Client in the event no Placement is
              obtained within the 90-day period. Refund will be credited to your original payment method with in 5 to 7 business days.
              <br />
              <span className="font-medium text-[#860F0B]">
                Non-Refundable Scenarios.
              </span>{" "}
              If Globelink successfully arranges an interview or engagement that
              leads to an offer of employment or contractual work—regardless of
              whether the Client accepts or rejects the offer—no refund will be
              issued.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              No Refunds Outside the 90-Day Non-Placement Exception
            </h2>
            <p className="text-gray-700 mb-4">
              <span className="font-medium text-[#75000e]">
                All Sales Final (Default Rule).
              </span>{" "}
              Except as stated in Section 2 above or as otherwise mandated by
              law, all payments to Globelink are final and non-refundable. This
              includes scenarios where:
              <ul className="list-disc pl-5">
                <li>
                  The Client voluntarily withdraws from the hiring process.
                </li>
                <li>
                  The Client refuses or fails to attend interviews scheduled by
                  Globelink.
                </li>
                <li>
                  The Client decides not to accept an offer of employment or
                  contractual work.
                </li>
                <li>
                  The Client’s employment or contract is later terminated by the
                  hiring company.
                </li>
              </ul>
            </p>
            <p className="text-gray-700">
              <span className="font-medium text-[#860F0B]">
                No Partial or Pro-Rated Refunds.
              </span>{" "}
              We do not provide partial refunds for any unused portions of our
              Services or partial engagement in training sessions.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              Other Applicable Laws and Exceptions
            </h2>
            <p className="text-gray-700">
              <span className="font-medium text-[#75000e]">
                Legal Requirements.
              </span>{" "}
              Certain jurisdictions may confer statutory rights or consumer
              protections that may supersede or modify this Policy. Where such
              laws require refunds under certain circumstances (unrelated to our
              90-day placement condition), we will comply accordingly.
              <br />
              <span className="font-medium text-[#860F0B]">
                Extraordinary Circumstances.
              </span>{" "}
              Globelink may, at its sole discretion, consider a refund request
              outside the scope of Section 2 if there is evidence of error,
              fraud, or significant non-performance directly attributable to
              Globelink. Any decision under this section is final and does not
              set a precedent for future requests.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              Disputes, Chargebacks & Contact Procedure
            </h2>
            <p className="text-gray-700">
              <span className="font-medium text-[#75000e]">
                Contact Us First.
              </span>{" "}
              If you believe a payment was made in error or you have a dispute
              regarding the Services, please contact our customer support at{" "}
              <a
                href="mailto:info@globelinkplacement.com"
                className="text-blue-600 hover:underline"
              >
                info@globelinkplacement.com
              </a>{" "}
              before initiating any chargeback or complaint. Most disputes can
              be resolved quickly through direct communication.
              <br />
              <span className="font-medium text-[#860F0B]">
                Unauthorized Chargebacks.
              </span>{" "}
              A chargeback or reversal initiated without prior discussion with
              Globelink may result in suspension of your Services or legal
              remedies pursued by Globelink.
              <br />
              <span className="font-medium text-[#75000e]">
                Documentation.
              </span>{" "}
              When requesting a refund under Section 2, you may be required to
              provide documentation to verify compliance with the Agreement,
              including evidence that you have participated in interviews and
              followed reasonable guidance provided by Globelink.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              Policy Updates
            </h2>
            <p className="text-gray-700">
              <span className="font-medium text-[#75000e]">
                Right to Amend.
              </span>{" "}
              We reserve the right to update or modify this Policy at any time.
              Any changes will become effective immediately upon posting the
              revised Policy on our website{" "}
              <a
                href="https://globelinkplacement.com/"
                className="text-blue-600 hover:underline"
              >
                https://globelinkplacement.com/
              </a>
              .
              <br />
              <span className="font-medium text-[#860F0B]">
                Acceptance of Changes.
              </span>{" "}
              By continuing to use our Services after any changes, you
              acknowledge and agree to be bound by the revised Policy. If you do
              not agree to the updated terms, you must cease use of our
              Services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              Contact Information
            </h2>
            <p className="text-gray-700">
              If you have any questions or concerns regarding this Refund Policy
              or need further clarification on its terms, please contact:
              <br />
              <span className="font-medium text-[#75000e]">Email:</span>{" "}
              <a
                href="mailto:info@globelinkplacement.com"
                className="text-blue-600 hover:underline"
              >
                info@globelinkplacement.com
              </a>
            </p>
          </section>

          <p className="text-gray-700 italic">
            We appreciate your trust in Globelink. Please read this Policy
            carefully before making any payments, and refer to the Agreement for
            Training and Placement Services for additional terms governing our
            relationship and obligations.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RefundPolicy;
